import { render } from "./SgaRegisteredFilter.vue?vue&type=template&id=3144a318"
import script from "./SgaRegisteredFilter.vue?vue&type=script&lang=js"
export * from "./SgaRegisteredFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__